<template>
  <div class="cpt-role-item">
    <RoleAvatar
      :img="role.icon"
      :color="
        isGradient
          ? role.color_list.map((c) => decimalToHexColor(c)).join(',')
          : decimalToHexColor(role.color)
      "
      :gradient="isGradient"
      size="middle"
      :icon="
        role.type == ROLE_TYPES.everyone ? 'icon-friends-request' : 'icon-admin'
      "
    />
    <span
      class="role-name"
      :style="{
        color: isGradient ? '' : role.color,
        'background-image': isGradient
          ? `linear-gradient(90deg, ${decimalToHexColor(
              role.color_list[0]
            )} 0%, ${decimalToHexColor(role.color_list[1])} 100%)`
          : '',
        'font-size': nameSize + 'px',
      }"
      :class="{
        'gradient-text': isGradient,
      }"
      v-emoji-html="{text: role.name, style: {width: `${nameSize}px`}}"
    />
    <slot></slot>
  </div>
</template>

<script>
import { ROLE_TYPES, IS_GRADIENT_LIST_COUNT } from "_lib/constants/role";
import RoleAvatar from "./RoleAvatar.vue";
import { decimalToHexColor } from "_lib/utils/utilsColor";


export default {
  name: "RoleItem",
  props: {
    role: {
      type: Object,
      default: () => {},
    },
    nameSize: {
      type: Number,
      default: 12,
    },
  },
  components: {
    RoleAvatar,
  },
  data() {
    return {
      ROLE_TYPES,
      IS_GRADIENT_LIST_COUNT,
    };
  },
  computed: {
    roleNameStyle() {
      return {
        color: this.role.color_list.length === IS_GRADIENT_LIST_COUNT ? "" : this.role.color,
        "background-image":
          this.color_list?.length === IS_GRADIENT_LIST_COUNT
            ? `linear-gradient(90deg, ${this.decimalToHexColor(
                this.color_list[0]
              )} 0%, ${this.decimalToHexColor(this.color_list[1])} 100%)`
            : "",
      };
    },
    isGradient() {
      return !!(this.role.color_list && (this.role.color_list.length === IS_GRADIENT_LIST_COUNT))
    },
  },
  methods: {
    decimalToHexColor: decimalToHexColor,
  },
};
</script>

<style lang="scss">
.cpt-role-item {
  display: flex;
  align-items: center;
  padding: 0 4px;
  height: 34px;
  color: $d-op-6;
  gap: 6px;
  .role-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: pre;
    &.gradient-text {
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      // display: inline-block;
    }
  }
}
</style>
